import './styles/Portfolio.css'
import { useState } from 'react'
import Resume from './Resume.js'
import placeholder from './placeholder.jpg'
import placeholderOverlay from './hadOne.jpg'
import userPages from './userPages.jpg'
import wordSearch from './wordSearch.jpg'


function Portfolio({setPortfolioPage}) {

    const [placeholderImg3, setPlaceholderImg3] = useState(placeholder)
    const [placeholderImg4, setPlaceholderImg4] = useState(placeholder)

    return (

        <>
            <div className='main-portfolio-wrapper'>
                <div className='sub-portfolio-wrapper'>
                    <div className='portfolio-row'>
                        <section className='portfolio-project'>
                            <img src={wordSearch} alt='placeholder' class='portfolio-img'></img>
                            <div className='portfolio-project-middle'>
                                <p className='portfolio-project-middle-text'>
                                    <a href='https://spellingbeeclone.netlify.app' target='_blank' rel="noopener noreferrer">
                                        View Project
                                    </a>
                                </p>
                            </div>
                        </section>
                        <section className='portfolio-project'>
                            <img src={userPages} alt='placeholder' class='portfolio-img' ></img>
                            <div className='portfolio-project-middle'>
                                <p className='portfolio-project-middle-text'>
                                    <a href='https://alternative-pitted-fruit.netlify.app' target='_blank' rel="noopener noreferrer">
                                        View Project
                                    </a>
                                </p>
                            </div>
                        </section>
                    </div>
                    <div className='portfolio-row'>
                        <section className='portfolio-project'>
                            <img src={placeholderImg3} alt='placeholder' class='portfolio-img'></img>
                            <div className='portfolio-project-middle'>
                                <p className='portfolio-project-middle-text' onClick={() => {placeholderImg3 === placeholder ? setPlaceholderImg3(placeholderOverlay) : setPlaceholderImg3(placeholder)}}>View Project</p>
                            </div>
                        </section>
                        <section className='portfolio-project'>
                            <img src={placeholderImg4} alt='placeholder' class='portfolio-img'></img>
                            <div className='portfolio-project-middle'>
                                <p className='portfolio-project-middle-text' onClick={() => {placeholderImg4 === placeholder ? setPlaceholderImg4(placeholderOverlay) : setPlaceholderImg4(placeholder)}}>View Project</p>
                            </div>
                        </section>
                    </div>
                    
                    
                </div>
                <div className='resume-button animation'>
                    <p>
                        <button className='resume-show' onClick={() => {setPortfolioPage('Resume')}} >
                            Resume
                        </button>
                    </p>
                </div>
            </div>
        </>
    )
}

export default function PortfolioHome() {

    const [portfolioPage, setPortfolioPage] = useState('Portfolio')
    
    return (
       <>
        {portfolioPage === 'Portfolio' && <Portfolio setPortfolioPage={setPortfolioPage} />}
        {portfolioPage === 'Resume' && <Resume setPortfolioPage={setPortfolioPage} />}
       </>
    ) 
}